import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CaretCompressIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M8,16.7l3.46-3.48a.78.78,0,0,1,1.08,0L16,16.7a.76.76,0,0,1-.54,1.3H8.54A.76.76,0,0,1,8,16.7Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8,7.3l3.46,3.48a.78.78,0,0,0,1.08,0L16,7.3A.76.76,0,0,0,15.46,6H8.54A.76.76,0,0,0,8,7.3Z"
  })]
}), 'CaretCompressIcon');